import React from "react";
import { Grid } from "@mui/material";
import { get } from "lodash";
import { connect } from "react-redux";
import { ConfigPropExtenderHoc } from "../../../../../common/StaticConfigProvider";
import OptionalToolTip from "../../../../../common/toolTip/OptionalToolTip";
import SelectDropDown from "../../../../../common/formElements/SelectDropDown";

interface ConfigurationProps {
  labelTooltip: string;
  isUpdateAllowed?: boolean;
  shouldHideField: (fieldName: string) => boolean;
}

interface ConfigurationHocProps {
  labelTooltip: string;
  toolTips?: { terminals?: { options?: Record<string, string> } };
  isUpdateAllowed?: boolean;
  shouldHideField: (fieldName: string) => boolean;
}

const ConfigurationStartup = (props: ConfigurationHocProps) => {
  const { labelTooltip, isUpdateAllowed, shouldHideField } = props;

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={4}>
        <OptionalToolTip
          tooltip={get(
            props,
            `toolTips.terminals.options.configuration.["${labelTooltip}"]`
          )}
        >
          <SelectDropDown
            fieldname="attributes.StartupMode"
            label="Startup mode 1"
            options={["Card", "Idle"]}
            disabled={!isUpdateAllowed}
          />
        </OptionalToolTip>
      </Grid>
    </Grid>
  );
};

const ConnectedConfigurationStartup = connect(
  null,
  null,
  (_stateProps, _dispatchProps, ownProps: ConfigurationHocProps) => {
    return {
      ...ownProps,
      shouldHideField: ownProps.shouldHideField,
    };
  }
)(ConfigurationStartup);

const ConnectedConfigurationStartupHoc = (props: ConfigurationProps) => (
  // @ts-ignore
  <ConfigPropExtenderHoc propName="toolTips">
    <ConnectedConfigurationStartup {...props} />
  </ConfigPropExtenderHoc>
);

export default ConnectedConfigurationStartupHoc;
